import React from "react";
import { useNavigate } from "react-router-dom";

interface TemplateCardProps {
  id: string;
  icon?: React.ReactNode;
  title: string;
  description: string;
}

const TemplateCard: React.FC<TemplateCardProps> = ({ id, icon, title, description }) => {
  const navigate = useNavigate();

  const handleClick = (id: string) => {
    navigate(`/generate-survey?template=${id}`);
  };

  return (
    <button
      onClick={() => handleClick(id)}
      className="bg-white p-4 rounded-xl shadow-md border border-gray-300 flex flex-col gap-2 w-full h-full cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all hover:shadow-lg active:scale-95"
    >
      {icon && (
        <div className="text-2xl">
          {icon}
        </div>
      )}
      <h3 className="font-semibold text-lg">
        {title}
      </h3>
      <p className="text-gray-600 text-sm">
        {description}
      </p>
    </button>
  );
};

export default TemplateCard;